import { RoleRouteConfig } from '@/modules/ta/role/RoleRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { RoleRoute, RolePathName } from '@/modules/ta/role/role.constants';

export const router = RoleRouteConfig.factory(
  [
    {
      path: `/${RoleRoute.ROLES}`,
      name: RolePathName.ROLES,
      component: () => import(/* webpackChunkName: "roles-page" */ './pages/RolesPage.vue'),
    },
    {
      path: `/${RoleRoute.ROLES}/new`,
      name: RolePathName.ROLEFORM_NEW,
      component: () => import(/* webpackChunkName: "role-form-page" */ './pages/RoleFormPage.vue'),
      props: true,
    },
    {
      path: `/${RoleRoute.ROLES}/:id`,
      name: RolePathName.ROLEFORM,
      component: () => import(/* webpackChunkName: "role-form-page" */ './pages/RoleFormPage.vue'),
      props: true,
    },
  ],
  Module.ROLE
);
